import React, { useEffect, useState } from 'react';
import { StyledListPost } from './StyledListPost';
import { connect, useDispatch } from 'react-redux';
import { List, Avatar, Empty, Skeleton, Button } from 'antd';

import { GET_LIST_POST_REQUEST, DELETE_POST_REQUEST } from '../constant';
import Layout from '../../Layout';
import { Link, useHistory } from 'react-router-dom';
import DuplicatePopup from '../DuplicatePopup';
import jwtDecode from 'jwt-decode';

const ListPost = ({ listPost, isLoadingPosts }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data, totalCount } = listPost;
  const [isShowDuplicatePopup, setIsShowDuplicatePopup] = useState(false);
  const [postId, setPostId] = useState(false);
  const [urlTitle, setURLTitle] = useState('');
  const [postLanguage, setPostLanguage] = useState(false);

  const onLoadMore = () => {
    dispatch({
      type: GET_LIST_POST_REQUEST,
      payload: {
        skip: data.length,
      },
    });
  };

  const loadMore = () => {
    return (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
        }}
      >
        <Button onClick={onLoadMore}>more</Button>
      </div>
    );
  };

  useEffect(() => {
    dispatch({
      type: GET_LIST_POST_REQUEST,
      payload: {
        skip: 0,
      },
    });
  }, [dispatch]);

  const handleDelete = id => {
    if (window.confirm('Are you sure?')) {
      dispatch({
        type: DELETE_POST_REQUEST,
        payload: {
          id,
        },
      });
    }
  };

  const handleDuplicate = (id, urlTitle, language) => {
    setPostId(id);
    setURLTitle(urlTitle);
    setPostLanguage(language);
    setIsShowDuplicatePopup(true);
  };

  let isAllowDuplicate = true;

  let dbName = null;
  let username = null;
  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode(token);
    dbName = decoded.dbName;
    username = decoded.username;
    switch (decoded.dbName) {
      case 'MY':
        isAllowDuplicate = false;
        break;
    }
  }

  const renderItem = item => {
    return (
      <List.Item
        className="list-item"
        extra={
          <div style={{ display: 'flex', gap: '10px' }}>
            {isAllowDuplicate && (
              <Button
                size="small"
                onClick={() => handleDuplicate(item.postId, item.urlTitle, item.language)}
              >
                Duplicate
              </Button>
            )}
            {username === 'bc' && (
              <Button size="small" onClick={() => handleDelete(item.postId)}>
                Delete
              </Button>
            )}
          </div>
        }
      >
        <Skeleton avatar title={false} loading={false} active>
          <List.Item.Meta
            onClick={() => history.push(`/posts/${item.postId}`)}
            avatar={<Avatar src={item.imageUrl} />}
            title={
              <Link
                to={{
                  pathname: `/posts/${item.postId}`,
                }}
              >
                {item.title}
              </Link>
            }
            description={item.description}
          />
        </Skeleton>
      </List.Item>
    );
  };

  return (
    <Layout title="Posts">
      <StyledListPost>
        {data.length > 0 ? (
          <List
            dataSource={data}
            loading={isLoadingPosts}
            itemLayout="horizontal"
            loadMore={data.length < totalCount ? loadMore() : null}
            className="list"
            renderItem={renderItem}
          />
        ) : (
          <Empty />
        )}
        {isShowDuplicatePopup && (
          <DuplicatePopup
            postId={postId}
            urlTitle={urlTitle}
            postLanguage={postLanguage}
            dbName={dbName}
            onClose={() => setIsShowDuplicatePopup(false)}
          />
        )}
      </StyledListPost>
    </Layout>
  );
};

export default connect(state => ({
  listPost: state.post.listPost,
  isLoadingPosts: state.post.isLoadingPosts,
  skip: state.post.skip,
}))(ListPost);
